import { http } from '@/api/http';
import { PaginatedApiResponseBody } from '@/api/types';
import { LogisticsGroundTrip, PaginatedGroundTripsQueryParams } from './drive-service.types';
import { getDriveServiceApiUrl } from './drive-service.paths';

const getLogisticsGroundTrips = async (params: PaginatedGroundTripsQueryParams) => {
  const res = await http.get<PaginatedApiResponseBody<LogisticsGroundTrip>>(
    getDriveServiceApiUrl.logisticsGroundTrips(),
    {
      params,
    },
  );

  return res.data.data;
};

export const driveServiceFetchers = {
  getLogisticsGroundTrips,
};
